import axios from 'axios';

import { SineHeader } from '../../shared/types';
import apiVersionService from './apiVersion.service';

function startsWith(haystack = '', needle = '') {
  return haystack.indexOf(needle) === 0;
}

const coreApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_CORE_API_URI)) {
    apiVersionService.setApiVersion('core', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(coreApiVersionInterceptor);
  }
  return response;
});

const workflowsApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_WORKFLOWS_API_URI)) {
    apiVersionService.setApiVersion('workflows', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(workflowsApiVersionInterceptor);
  }
  return response;
});

const companiesApiVersionInterceptor = axios.interceptors.response.use((response) => {
  if (startsWith(response.config.url, window.env.REACT_APP_SINE_COMPANIES_API_URI)) {
    apiVersionService.setApiVersion('companies', response.headers[SineHeader.X_SINE_VERSION] || 'Unknown');
    axios.interceptors.response.eject(companiesApiVersionInterceptor);
  }
  return response;
});
